import { Pipe, PipeTransform } from '@angular/core';

import { RouteSegmentService } from '../core/upgraded-providers';


@Pipe({
    name: 'routeSegmentUrl'
})
export class RouteSegmentUrlPipe implements PipeTransform {

    constructor(
        private _routeSegment: RouteSegmentService
    ) {
    }

    transform(segmentName: string, params?: any): any {
        return this._routeSegment.getSegmentUrl(segmentName, params);
    }

}
